import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { contactsApi } from 'src/Services/API';
import { ContactDto, CreateContactDto } from 'src/Services/API/generated';
import { trackEvent } from 'src/Services/Matomo';

export const useCreatePhysicalContact = (
  options?: UseMutationOptions<ContactDto | undefined, unknown, CreateContactDto>
) => {
  const queryClient = useQueryClient();
  const assetId = useCurrentAssetId();

  return useMutation<ContactDto | undefined, unknown, CreateContactDto>(
    ['create-physical-contact', assetId],
    async contact => {
      if (!assetId) {
        throw new Error('No asset selected');
      }
      const response = await contactsApi.contactsControllerCreate(assetId, contact);
      return response.data;
    },
    {
      ...options,
      onSuccess: (data, variables, context) => {
        trackEvent('Contact', 'create', data?.displayName);
        queryClient.invalidateQueries('fetch-contacts');
        queryClient.invalidateQueries(['fetch-asset-details', assetId]);
        options?.onSuccess?.(data, variables, context);
      },
    }
  );
};
